import { useRequest } from "hooks";
import type { ResourceResponse, ThunkReturnType } from "types";
import { ApiRouteTypes } from "consts/enpoints/api";
import useExportTable from "hooks/useExportTable";
import type { BankingSdkConnector, BankingSdkConnectorsResponse } from "../types";
import { getBankingSdkConnectorsThunk, updateBankingSdkConnectorThunk } from "../thunks";
import { changeExportBankingSdkConnectorsLoading as changeExportLoading } from "../slice";

export const useBankingSDKActions = () => {
    const getBankingSdkConnectors = useRequest<
        ThunkReturnType<BankingSdkConnectorsResponse>,
        string | undefined
    >({
        thunk: getBankingSdkConnectorsThunk
    });

    const updateBankingSdkConnector = useRequest<
        ThunkReturnType<ResourceResponse<BankingSdkConnector>>,
        Partial<BankingSdkConnector>
    >({
        thunk: updateBankingSdkConnectorThunk
    });

    const downloadCsv = useExportTable({
        changeExportLoading,
        apiResourceType: ApiRouteTypes.GetBankingSdkConnectors
    });

    return {
        getBankingSdkConnectors,
        updateBankingSdkConnector,
        downloadCsv
    };
};

export default useBankingSDKActions;
